// Map an RM's unique identifier (email recommended) to an avatar image URL.
export const RM_AVATARS: Record<string, string> = {
  'andrew.vanam@libertasfunding.com':
    'https://libertas-public-assets.s3.us-east-1.amazonaws.com/photos/AndrewVanamPfPic.jpeg',

  'david.goldberg@libertasfunding.com':
    'https://libertas-public-assets.s3.us-east-1.amazonaws.com/photos/DavidGoldBergPfPic.png',

  'mathais.grez@libertasfunding.com':
    'https://libertas-public-assets.s3.us-east-1.amazonaws.com/photos/Mathais+Grez+ProfilePic.jpeg',

  'john.paradisi@libertasfunding.com':
    'https://libertas-public-assets.s3.us-east-1.amazonaws.com/photos/JohnParadisiPfPic.webp',

  'zachary.marti@libertasfunding.com':
    'https://libertas-public-assets.s3.us-east-1.amazonaws.com/photos/ZacharyMartiPfpic.jpeg',
};
